<template>
    <div class="row">
        <div class="item-wrap" :class="{ itemBorder: index > 0 }">
            <div class="item-wrap-inner" :class="{ itemfade: isComplete || isBlocked }">
                <div class="item">
                    <checkbox :state="itemCheckboxState"
                              @clicked="checkboxClick"
                              :parent-loading="loading">
                    </checkbox>
                    <a href="#"
                       @click="titleClick"
                       class="item-title"
                       :style="{ maxWidth: item.users.length ? '60%' : '70%' }"
                       :title="'Quote #'+item.quote.id+', Item #'+item.id">
                        {{ itemTitle }}
                    </a>
                    <div :class="['stat', percentClass]" title="Percent Completed">
                        {{ percentComplete }}%
                    </div>
                    <div v-if="item.production_sheet_url" class="prod-sheet-icon" title="Production Sheet">
                        <a :href="item.production_sheet_url" data-ajax="false" target="_blank">
                            <i class="fal fa-file-alt fa-fw fa-fw"></i>
                        </a>
                    </div>

                    <div class="item-print"
                         @click="showPrintModal()"
                         title="Print item label">
                        <i class="fas fa-print"></i>
                    </div>

                    <ready-for-inspection-button
                        v-if="auth_user.is_block3_submitter"
                        :quote-id="item.quote.id"
                        @submitted="onReadySubmitted">
                    </ready-for-inspection-button>
                    <v-easy-dialog v-model="printModal">
                        <div class="v-easy-dialog-wrap">
                            <div class="v-easy-dialog-title title-bar">
                                Print: Packing Label (Large)
                            </div>

                            <div v-if="Object.keys(printers).length">
                                <span class="admin-modal-label">Printer</span>
                                <select name="printer_name" v-model="printModalPackingPrinter">
                                    <option v-for="printer in printersPacking"
                                            :value="printer.printer_key"
                                            :key="printer.printer_key">
                                        {{ printer.name }}
                                    </option>
                                </select>
                            </div>
                            <div v-else>
                                <span class="admin-modal-label">No Printers Online!</span>
                            </div>

                            <div v-if="Object.keys(printers).length && item.quantity > 1">
                                <span class="admin-modal-label">Quantity</span>
                                <span class="checklist-radios">
                                <span>
                                    <input type="radio" id="print-quantity-default" name="print-quantity" :value="1" v-model="printModalPackingQuantity">
                                    <label for="print-quantity-default">1</label>
                                </span>
                                <span>
                                    <input type="radio" id="print-quantity-all" name="print-quantity" :value="item.quantity" v-model="printModalPackingQuantity">
                                    <label for="print-quantity-all">{{ item.quantity }}</label>
                                </span>
                            </span>
                            </div>

                            <div class="v-easy-dialog-controls">
                                <button
                                    class="btn-qapp"
                                    :disabled="!printModalPackingPrinter || !Object.keys(printers).length"
                                    @click="printPackingSubmit()">Print</button>
                            </div>
                        </div>
                    </v-easy-dialog>

                    <div v-if="item.deadline.label" :class="['stat', deadlineClass]" title="Deadline">
                        {{ item.deadline.label }}
                    </div>
                </div>
                <div v-if="expanded" class="process-wrap">
                    <process v-for="(process, i) in visibleProcesses"
                             :key="itemCheckboxState + process.id"
                             :process="process"
                             :itemTitle="itemTitle"
                             :clientName="item.quote.name"
                             :companyName="item.quote.company"
                             :quantity="item.quantity"
                             :itemName="item.name"
                             :checkedSum="checkedSum"
                             :itemLoading="loading"
                             :users_select="users_select"
                             :printers="printers"
                             :auth_user="auth_user"
                             :user_id_filter="user_id">
                    </process>
                    <div v-if="auth_user.is_admin" class="add-process-row">
                        <a href="#" @click.prevent="showAddProcessModal()" class="add-process-link">
                            <i class="fas fa-plus"></i> Add process
                        </a>
                    </div>
                    <v-easy-dialog v-model="addProcessModal">
                        <div class="v-easy-dialog-wrap">
                            <div class="v-easy-dialog-title">
                                <span>Add process to</span>
                                <b>{{ itemTitle }}</b>
                            </div>

                            <div>
                                <span class="admin-modal-label">Process name</span>
                                <input type="text" maxlength="255" v-model="addProcessName" placeholder="e.g. Re-stretch canvas" />
                            </div>

                            <div>
                                <span class="admin-modal-label">Workcentre</span>
                                <select v-model="addProcessWorkcentreId">
                                    <option :value="null">— None —</option>
                                    <option v-for="wc in workcentresList"
                                            :value="wc.id"
                                            :key="wc.id">{{ wc.name }}</option>
                                </select>
                            </div>

                            <div>
                                <span class="admin-modal-label">Minutes</span>
                                <input type="number" min="0" max="10000" step="1" v-model.number="addProcessMinutes" />
                            </div>

                            <div>
                                <span class="admin-modal-label">People required</span>
                                <input type="number" min="1" max="9" step="1" v-model.number="addProcessNumPeople" />
                            </div>

                            <div class="v-easy-dialog-controls">
                                <button class="btn-qapp" :disabled="addProcessLoading || !addProcessName" @click="addProcessSubmit()">
                                    {{ addProcessLoading ? 'Adding…' : 'Add process' }}
                                </button>
                            </div>
                        </div>
                    </v-easy-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {default as _} from "lodash";
import Process from "../production_checklist/Process";
import Checkbox from "../production_checklist/Checkbox";
import ReadyForInspectionButton from "../production_checklist/ReadyForInspectionButton";
import api from "../../api";
import VEasyDialog from 'v-easy-dialog'

    export default {

        props: {
            item: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            expanded_by_default: {
                type: Boolean,
            },
            workcentre_id: {
                type: Number,
            },
            user_id: {
                type: Number,
            },
            workcentre_filter_ids: {
                type: Array,
                required: true,
            },
            auth_user: {
                type: Object,
                required: true,
            },
            users_select: {
                type: Array,
                required: true
            },
            printers: {
                required: true
            },
        },

        data: () => ({
            processesHidden: true,
            loading: false,
            expanded: false,
            printModal: false,
            printModalPackingPrinter: null,
            printModalPackingQuantity: 1,
            addProcessModal: false,
            addProcessLoading: false,
            addProcessName: '',
            addProcessWorkcentreId: null,
            addProcessMinutes: 0,
            addProcessNumPeople: 1,
            workcentresList: [],
        }),

        mounted() {
            this.expanded = this.expanded_by_default;
        },

        components: {
            Process,
            Checkbox,
            VEasyDialog,
            ReadyForInspectionButton,
        },

        methods: {
            showPrintModal() {
                if (this.loading || this.itemLoading === true)
                    return false;

                let lastUsedPrinter = localStorage.getItem('printModalPackingPrinter');
                if (!this.printModalPackingPrinter)
                    this.printModalPackingPrinter = lastUsedPrinter;

                this.printModal = true;
            },
            showAddProcessModal() {
                if (! this.auth_user.is_admin) return false;
                if (this.loading || this.addProcessLoading) return false;

                this.addProcessName = '';
                this.addProcessWorkcentreId = null;
                this.addProcessMinutes = 0;
                this.addProcessNumPeople = 1;
                this.addProcessModal = true;

                if (! this.workcentresList.length) {
                    api.getChecklistWorkcentres().then(data => {
                        if (Array.isArray(data)) this.workcentresList = data;
                    });
                }
            },
            addProcessSubmit() {
                if (this.addProcessLoading) return false;

                let name = (this.addProcessName || '').trim();
                if (! name) return false;

                let minutes = parseInt(this.addProcessMinutes, 10);
                if (isNaN(minutes) || minutes < 0 || minutes > 10000) return false;

                let numPeople = parseInt(this.addProcessNumPeople, 10);
                if (isNaN(numPeople) || numPeople < 1 || numPeople > 9) numPeople = 1;

                this.addProcessLoading = true;

                api.addChecklistProcess(
                    this.item.id,
                    name,
                    this.addProcessWorkcentreId,
                    minutes,
                    numPeople
                ).then(data => {
                    this.addProcessLoading = false;

                    // No data on the response means an error toast was shown by axiosCatch.
                    // Leave the modal open so PM can correct the name and resubmit.
                    if (! data || ! data.id) return;

                    this.addProcessModal = false;

                    // Reload the full items list so the new process appears with all
                    // hydrated relations (status, workcentre order, etc).
                    if (this.$parent && typeof this.$parent.loadItems === 'function')
                        this.$parent.loadItems();
                });
            },
            printPackingSubmit() {
                if (this.loading || this.itemLoading === true || !this.printModalPackingPrinter)
                    return false;

                localStorage.setItem('printModalPackingPrinter', this.printModalPackingPrinter);

                this.loading = true;

                api.printLabel(
                    'packing',
                    this.item.id,
                    this.auth_user.id,
                    this.printModalPackingPrinter,
                    this.printModalPackingQuantity
                )
                    .then(data => {
                        this.loading = false;
                        this.printModal = false;
                        this.printModalPackingQuantity = 1;
                    });
            },
            shouldShowProcess(workcentre_id) {
                if (this.workcentre_filter_ids.length === 0)
                    return true;

                return this.workcentre_filter_ids.includes(workcentre_id);
            },
            onReadySubmitted() {
                // Submission is handled server-side via the ready endpoint;
                // the Block 3 signoff row is created by the ProductionComplete
                // listener. No local store mutation needed — the inspector
                // sees the quote appear in their tab on next /api/signoff
                // poll.
            },
            titleClick(event) {
                this.expanded = !this.expanded;
                this.$emit('item_expanded', { id: this.item.id, expanded: this.expanded });
            },
            checkboxClick() {
                if (this.loading === true)
                    return false;

                this.loading = true;
                let checked = this.itemCheckboxState === 'checked' ? 0 : 1;

                let item = this.$actions.getItem(this.item.id);

                // Optimistic update — skip multi-person processes when checking
                // (they need enough ticks, can't just force checked=1)
                _.forEach(item.production_checklists, function (process) {
                    if (checked === 1 && (process.num_people_required || 1) > 1) return;
                    process.checked = checked;
                });

                api.updateChecklist('item', this.item.id, checked, this.workcentre_id, this.user_id)
                    .then(data => {
                        this.loading = false;
                        if (!data || !Array.isArray(data)) return;

                        data.forEach(serverProcess => {
                            let local = item.production_checklists.find(p => p.id === serverProcess.id);
                            if (!local) return;
                            local.checked = serverProcess.checked;
                            local.user = serverProcess.user;
                            local.user_id = serverProcess.user_id;
                            local.updated_at = serverProcess.updated_at;
                            local.ticks_count = serverProcess.ticks_count;
                            local.ticks_required = serverProcess.ticks_required;
                            local.ticked_by = serverProcess.ticked_by || [];
                            local.ticked_by_user_ids = serverProcess.ticked_by_user_ids || [];
                            local.num_people_required = serverProcess.num_people_required;
                        });
                    });

            },
        },

        computed: {
            printersPacking() {
                return _.filter(this.printers, ['modelName', 'DYMO LabelWriter 450']);
            },
            itemCheckboxState() {
                let processes = this.visibleProcesses
                let num_checked = _.sumBy(processes, 'checked');

                if (num_checked === 0)
                    return 'unchecked';

                if (processes.length === num_checked)
                    return 'checked';

                return 'mixed';
            },
            percentComplete() {
                let checked = _.filter(this.item.production_checklists, 'checked');

                return (checked.length === this.item.production_checklists.length) && this.workcentre_id === null && this.user_id === null
                    ? 100
                    : _.sumBy(checked, 'percent');
            },
            visibleProcesses() {
                let self = this;
                return this.item.production_checklists.filter(function(process) {
                    return self.shouldShowProcess(process.workcentre_id);
                });
            },
            isComplete() {
                return this.itemCheckboxState === 'checked';
            },
            isBlocked() {
                return this.visibleProcesses.filter(process => process.status === 'blocked').length === this.visibleProcesses.length;
            },
            deadlineClass() {
                if (this.itemCheckboxState === 'checked')
                    return 'deadline';

                if (this.item.deadline.isToday || this.item.deadline.isPast)
                    return 'deadline deadline-past';

                if (this.item.deadline.isCurrentWeek)
                    return 'deadline deadline-current-week';

                return 'deadline';
            },
            percentClass() {
                return 'percent-' + Math.floor(this.percentComplete / 20) * 20;
            },
            checkedSum() {
                return _.sumBy(this.item.production_checklists, 'checked');
            },
            itemTitle() {
                return this.item.quote.name + ' - ' + this.item.quantity + ' x ' + this.item.name;
            }
        },
    }
</script>

<style>
    .item-wrap {}
    .itemBorder {
        border-top: 1px solid #e1e1e1;
    }
    .item-wrap-inner {
        display: flex;
        flex-direction: column;
    }
    .item {
        display: flex;
        align-items: center;
    }
    .item-title {}
    a.item-title {
        outline: 0;
        font-size: 16px;
        display: flex;
        align-items: center;
        font-weight: bold;
        padding: 15px 20px 15px 10px;
        color: #1e1e1e !important;
    }
    a.item-title:hover, a.item-title:active, a.item-title:focus {
        text-decoration: none;
    }
    a.item-title:hover {
        color: #063eaa !important;
    }
    .process-wrap {
        margin: 0 0 20px 0;;
    }
    .add-process-row {
        margin: 10px 0 0 22px;
    }
    .add-process-link {
        color: #777;
        font-size: 13px;
        text-decoration: none;
    }
    .add-process-link:hover {
        color: #0d4988;
        text-decoration: none;
    }
    .add-process-link .fas {
        margin-right: 4px;
    }

    .users {
        margin-left: auto;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .edit-users-list {
        position: absolute;
        border: 1px solid #b7b7b7;
        right: 0;
        width: 250px;
        padding: 10px 10px 10px 5px;
        background-color: #fff;
        z-index: 1;
        box-shadow: 0 5px 20px #8c8c8c;
        border-radius: 5px;
        display: flex;
        flex-wrap: wrap;
    }

    .edit-users-btn {
        visibility: visible;
        border: 1px solid #d0d0d0;
        padding: 8px 10px 8px 13px;
        border-radius: 3px;
        color: #909090;
        background-color: #fff;
        user-select: none;
    }
    .edit-users-btn:active, .edit-users-btn:focus, .edit-users-btn:hover {
        border: 1px solid #368442;
        background-color: #e6f7e8;
        color: #0e6b1d;
    }

    .user-active {
        opacity: 1;
    }

    .user-tick {
        color: #069f06;
        font-size: 18px;
        display: inline-block;
        margin-right: 6px;
        font-weight: bold;
        background-image: url(/img/icons/tick_32x32.png);
        background-position: center, center;
        background-size: 16px;
        width: 16px;
        height: 16px;
    }
    .user-tick-hidden {
        color: #fff;
        user-select: none;
        background-image: none;
    }
    .user-inactive {
        opacity: 0.6;
    }

    .user-list-badge {
        margin: 0;
        cursor: pointer;
    }

    .user-list-badge-wrap {
        margin: 12px;
        background-color: #fff;
        padding: 5px;
        border-radius: 5px;
        display: flex;
        align-items: center;
    }
    .user-list-badge-wrap.user-active {
        background-color: green;
    }

    .itemfade {
        opacity: 0.3;
        transition: opacity 3s linear;
    }
    .item-wrap-inner.itemfade:hover {
        opacity: 1;
        transition: opacity 0s linear;
    }

    .deadline {
        background-color: #9b9b9b;
        margin-left: auto;
    }
    .deadline-past, .deadline-today {
        background-color: #b50707;
    }
    .deadline-current-week {
        background-color: #2565b7;
    }

    .percent-100 { background-color: #006900; }
    .percent-80 { background-color: #0d730d; }
    .percent-60 { background-color: #1d791d; }
    .percent-40 { background-color: #337a33; }
    .percent-20 { background-color: #4d774d; }
    .percent-0 { background-color: #6b6f6b; }


    .slide-enter-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: linear;
        -webkit-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: linear;
        -webkit-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
    }

    .slide-enter-to, .slide-leave {
        max-height: 1000px;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }


    @media (min-width: 768px) {

    }
    @media (min-width: 992px) {
        a.item-title { font-size: 18px; }
    }

    .prod-sheet-icon {
        font-size: 21px;
        padding-top: 1px;
    }
    .item-print {
        margin-left: 22px;
        color: #777;
        cursor: pointer;
    }
    .item-print:hover {
        color: #000000;
    }

</style>
